module.exports = __webpack_public_path__ + "assets/incoming.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/incoming.png
// module id = 1203
// module chunks = 7